export default __webpack_public_path__ + "static/media/Noddy.5f1a454a.webm";